import {
  LayoutDashboard, Users, BarChart2, Bell, FileText,
  Settings, Gift, Star, Ticket,
  Gamepad2, Trophy, Tag, CalendarDays, QrCode,
  Send, Workflow, Mail, Bot, Sparkles, Image,
  UtensilsCrossed, ClipboardList, Printer, ShoppingBag, TicketCheck,
  Building, MapPin, Palette, UserCog, Link2, Phone, Receipt, CreditCard,
  TrendingUp, Truck, Bike, PieChart, ShoppingCart, Shield, BookmarkPlus,
  Wallet, ShieldCheck,
} from 'lucide-react';

const ADMIN_ROUTES = [
  // ── DASHBOARD ──
  { to: '/admin', label: 'Overview', icon: LayoutDashboard, color: '#D44E20', group: 'DASHBOARD', end: true },
  { to: '/admin/reports', label: 'Report', icon: FileText, color: '#10B981', group: 'DASHBOARD' },
  { to: '/admin/social-proofs', label: 'Notifiche', icon: Bell, color: '#F59E0B', group: 'DASHBOARD' },

  // ── ANALYTICS ──
  { to: '/admin/analytics', label: 'Analisi Loyalty', icon: BarChart2, color: '#8B5CF6', group: 'ANALYTICS' },
  { to: '/admin/sales-analytics', label: 'Analisi Shop', icon: TrendingUp, color: '#D44E20', group: 'ANALYTICS' },
  { to: '/admin/analytics-orders', label: 'Analisi Ordini', icon: PieChart, color: '#3B82F6', group: 'ANALYTICS' },
  { to: '/admin/timeline', label: 'Eventi importanti', icon: BookmarkPlus, color: '#64748B', group: 'ANALYTICS' },

  // ── LOYALTY / REFERRAL ──
  { to: '/admin/program', label: 'Programma', icon: Settings, color: '#64748B', group: 'LOYALTY / REFERRAL' },
  { to: '/admin/premi', label: 'Premi', icon: Gift, color: '#EF4444', group: 'LOYALTY / REFERRAL' },
  { to: '/admin/gift-points', label: 'Regala Punti e Coupon', icon: Star, color: '#3B82F6', group: 'LOYALTY / REFERRAL' },
  { to: '/admin/customers', label: 'Clienti', icon: Users, color: '#3B82F6', group: 'LOYALTY / REFERRAL' },
  { to: '/admin/coupons', label: 'Coupon', icon: Ticket, color: '#10B981', group: 'LOYALTY / REFERRAL' },

  // ── ENGAGEMENT ──
  { to: '/admin/games', label: 'Giochi', icon: Gamepad2, color: '#8B5CF6', group: 'ENGAGEMENT' },
  { to: '/admin/challenges', label: 'Challenge', icon: Trophy, color: '#F59E0B', group: 'ENGAGEMENT' },
  { to: '/admin/promozioni', label: 'Promozioni', icon: Tag, color: '#EC4899', group: 'ENGAGEMENT' },
  { to: '/admin/events', label: 'Eventi', icon: CalendarDays, color: '#10B981', group: 'ENGAGEMENT' },
  { to: '/admin/campaigns', label: 'Campagne Fisiche', icon: QrCode, color: '#64748B', group: 'ENGAGEMENT' },

  // ── COMUNICAZIONE ──
  { to: '/admin/broadcast', label: 'Broadcast', icon: Send, color: '#D44E20', group: 'COMUNICAZIONE' },
  { to: '/admin/automations', label: 'Automazioni', icon: Workflow, color: '#10B981', group: 'COMUNICAZIONE' },
  { to: '/admin/email-templates', label: 'Template Email', icon: Mail, color: '#3B82F6', group: 'COMUNICAZIONE' },
  { to: '/admin/whatsapp-bot', label: 'Bot WhatsApp', icon: Bot, color: '#10B981', group: 'COMUNICAZIONE' },
  { to: '/admin/strategy', label: 'Strategia AI', icon: Sparkles, color: '#D44E20', group: 'COMUNICAZIONE' },
  { to: '/admin/image-builder', label: 'Image Builder', icon: Image, color: '#F59E0B', group: 'COMUNICAZIONE' },

  // ── CIBO & ORDINI ──
  { to: '/admin/menu', label: 'Menu e Take-Away', icon: UtensilsCrossed, color: '#E85D04', group: 'CIBO & ORDINI' },
  { to: '/admin/orders', label: 'Ordini', icon: ClipboardList, color: '#10B981', group: 'CIBO & ORDINI' },
  { to: '/admin/delivery', label: 'Consegna a Domicilio', icon: Truck, color: '#6366F1', group: 'CIBO & ORDINI' },

  // ── SHOP ──
  { to: '/admin/shop', label: 'Merchandising', icon: ShoppingBag, color: '#D44E20', group: 'SHOP' },
  { to: '/admin/events-tickets', label: 'Biglietti Eventi', icon: TicketCheck, color: '#F59E0B', group: 'SHOP' },
  { to: '/admin/print', label: 'Stampe e Volantini', icon: Printer, color: '#8B5CF6', group: 'SHOP' },

  // ── IMPOSTAZIONI ──
  { to: '/admin/brand', label: 'Brand', icon: Building, color: '#64748B', group: 'IMPOSTAZIONI' },
  { to: '/admin/venues', label: 'Punti Vendita', icon: MapPin, color: '#D44E20', group: 'IMPOSTAZIONI' },
  { to: '/admin/staff', label: 'Staff', icon: UserCog, color: '#64748B', group: 'IMPOSTAZIONI' },
  { to: '/admin/riders', label: 'Rider', icon: Bike, color: '#EC4899', group: 'IMPOSTAZIONI' },
  { to: '/admin/billing', label: 'Fatturazione', icon: Receipt, color: '#10B981', group: 'IMPOSTAZIONI' },
  { to: '/admin/integrations', label: 'Integrazioni', icon: Link2, color: '#3B82F6', group: 'IMPOSTAZIONI', end: true },
  { to: '/admin/diagnostics', label: 'Diagnostica link', icon: ShieldCheck, color: '#10B981', group: 'IMPOSTAZIONI' },
  { to: '/admin/wallet-preview', label: 'Wallet Pass (anteprima)', icon: Wallet, color: '#1A1A1A', group: 'IMPOSTAZIONI' },
  { to: '/admin/integrations/payments', label: 'Pagamenti Shop', icon: CreditCard, color: '#635BFF', group: 'IMPOSTAZIONI' },
  { to: '/admin/tracking', label: 'Tracking & Pixel', icon: BarChart2, color: '#F9AB00', group: 'IMPOSTAZIONI' },
  { to: '/admin/security', label: 'Sicurezza', icon: Shield, color: '#EF4444', group: 'IMPOSTAZIONI' },
];

export const ADMIN_GROUPS = ['DASHBOARD', 'ANALYTICS', 'LOYALTY / REFERRAL', 'ENGAGEMENT', 'COMUNICAZIONE', 'CIBO & ORDINI', 'SHOP', 'IMPOSTAZIONI'];
export const ADMIN_ROUTE_MAP = ADMIN_ROUTES.reduce((map, r) => { map[r.to] = r; return map; }, {});
export const getRoutesByGroup = (group) => ADMIN_ROUTES.filter(r => r.group === group);
export default ADMIN_ROUTES;
